import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Gavel } from "lucide-react";

interface ReviewMotionsTabProps {
  data: any;
}

export function ReviewMotionsTab({ data }: ReviewMotionsTabProps) {
  if (!data.motions || data.motions.length === 0) {
    return (
      <Card className="p-12 text-center">
        <Gavel className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-muted-foreground">No motions recorded</p>
      </Card>
    );
  }

  const getResultColor = (result: string) => {
    switch (result) {
      case "passed": return "default";
      case "failed": return "destructive";
      case "tabled": return "secondary";
      case "withdrawn": return "outline";
      default: return "outline";
    }
  };

  return (
    <div className="space-y-4">
      {data.motions.map((motion: any, index: number) => (
        <Card key={index} className="p-6">
          <div className="space-y-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <Badge variant={getResultColor(motion.vote_result)}>
                    {motion.vote_result || "Pending"}
                  </Badge>
                </div>
                <p className="font-medium text-lg">{motion.motion_text}</p>
              </div>
              <div className="text-sm text-muted-foreground text-right">
                Motion #{index + 1}
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4 text-sm">
              {motion.made_by && (
                <div>
                  <span className="text-muted-foreground">Made by: </span>
                  <span className="font-medium">{motion.made_by}</span>
                </div>
              )}
              {motion.seconded_by && (
                <div>
                  <span className="text-muted-foreground">Seconded by: </span>
                  <span className="font-medium">{motion.seconded_by}</span>
                </div>
              )}
            </div>

            {motion.discussion_summary && (
              <div className="p-3 bg-muted rounded-lg">
                <p className="text-sm font-medium mb-1">Discussion Summary:</p>
                <p className="text-sm text-muted-foreground whitespace-pre-wrap">
                  {motion.discussion_summary}
                </p>
              </div>
            )}

            {motion.vote_result && (
              <div className="flex items-center gap-6 p-3 border rounded-lg">
                <div className="flex-1 text-center">
                  <p className="text-2xl font-bold text-green-600">{motion.votes_for || 0}</p>
                  <p className="text-xs text-muted-foreground">For</p>
                </div>
                <div className="flex-1 text-center">
                  <p className="text-2xl font-bold text-red-600">{motion.votes_against || 0}</p>
                  <p className="text-xs text-muted-foreground">Against</p>
                </div>
                <div className="flex-1 text-center">
                  <p className="text-2xl font-bold text-muted-foreground">{motion.abstentions || 0}</p>
                  <p className="text-xs text-muted-foreground">Abstained</p>
                </div>
              </div>
            )}
          </div>
        </Card>
      ))}
    </div>
  );
}
